import React from "react";

import { MobileOrderDetailsWrap } from "../catalogue.styles";
import AddedItems from "./AddedItems";
import TotalSummaryCharge from "./TotalSummaryCharge";
import OrderHeaderSection from "./OrderHeaderSection";
import BackButton from "../../../../../../../library/BackButton/BackButtonNew";

const MobileOrderDetails = ({ handleGoBack, totalPrice }) => {
    return (
        <MobileOrderDetailsWrap>
            <div className="sales__order-mobile-top-wrap">
                <BackButton onClick={handleGoBack} />
            </div>
            <OrderHeaderSection />
            <AddedItems />
            <TotalSummaryCharge {...{ totalPrice }} />
        </MobileOrderDetailsWrap>
    );
};

export default MobileOrderDetails;
